import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 23,
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
}));

export default function EscogerBusqueda(props) {
  const [value, setValue] = React.useState('');
  const classes = useStyles();
  const { onSelectTipo, captchaExpiro, onResetCaptcha } = props;
  const { t } = useTranslation(['translation', 'pagos']);

  React.useEffect(() => {
    // console.log("[busqueda] captchaExpiro", captchaExpiro);
    if (captchaExpiro) {
      setValue('');
      onResetCaptcha(false);
    }
  });

  const handleChange = (event) => {
    // console.log('-------');
    // console.log('value', event.target.value);
    // console.log('-------');
    setValue(event.target.value);
    onSelectTipo(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" className={classes.root}>{t('pagos:tipobusqueda','Selecciona como harás tu búsqueda')}</FormLabel>
      <RadioGroup row aria-label="gender" name="gender1" value={value} onChange={handleChange} className={classes.instructions}>
        <FormControlLabel value="cuenta" control={<Radio />} label={t('pagos:numerocuenta')}/>
        <FormControlLabel value="teléfono" control={<Radio />} label={t('pagos:numerotelefono')} />
      </RadioGroup>
    </FormControl>
  );
}
